---
nb:
  notifications:
    admin:
      channels:
        email: E-post
        portal_toast: Portal-toast
      composer:
        fields:
          all_users: Alle brukere
          body: Meldingstekst
          channels: Kanaler
          community_post: Lenk til community-innlegg
          context_url: Kontekst-URL (valgfritt)
          direct_users: Direkte mottakere
          features: Funksjonsflagg
          portfolios: Porteføljer
          scope: Omfang
          send: Send varsel
          severity: Alvorlighetsgrad
          title: Tittel
        hints:
          all_users_caption: Bruk med varsomhet ved brede utsendelser.
          all_users_tooltip: Sender til alle aktive portalbrukere innenfor gjeldende tilgang.
          channels: Velg leveringskanaler og målgrupper før sending.
          context: Legg til en valgfri lenke som forklarer hvorfor varselet er relevant.
          layout_intro: Bygg meldingen først, og bekreft mottakere og kanaler før du sender.
          targeting: Kombiner direkte brukere, porteføljer og funksjonsflagg for å styre hvem som mottar varselet.
        preview:
          direct_users: Direkte brukere
          features: Funksjonsflagg
          portfolios: Porteføljer
        preview_headers:
          email: E-post
          recipient: Mottaker
        recipient_notice:
          all_users: Sender til alle portalbrukere.
          direct_summary: "{count} direkte"
          feature_summary: "{count} via {feature}"
          loading: Beregner antall mottakere...
          portfolio_summary: "{count} fra {name}"
          select: Velg minst én mottaker via direkte brukere, porteføljer eller funksjonsflagg.
          separator: " • "
          summary: Sender til {count} mottakere{details}
        sections:
          audience: Målgruppe
          channels: Kanaler og segmenter
          context: Meldingskontekst
          delivery: Levering
          message: Meldingsinnhold
          preview: Mottakeroversikt
          review: Gjennomgang og sending
          settings: Varslingsinnstillinger
          targeting: Direkte målgrupper
        send_summary:
          channels: 'Kanaler: {value}'
          no_channels: Ingen kanaler valgt
          recipients: 'Mottakere: {count}'
          scope: 'Omfang: {value}'
          scope_all_users: Alle brukere
          scope_selected: Valgte mottakere
          severity: 'Alvorlighetsgrad: {value}'
          title: Sendesammendrag
        severities:
          error: Feil
          info: Info
          success: Suksess
          warning: Advarsel
        title: Opprett varsel
      delivery_status_reasons:
        email_channel_disabled: E-postkanal deaktivert
        invalid_email: Ugyldig e-postformat
        missing_recipient_email: Mangler mottakeradresse
        missing_user_mapping: Mangler bruker-tilknytning
        portal_toast_channel_disabled: Portal-toast deaktivert
        portal_toast_opted_out: Bruker har deaktivert popup-varsler
        whitelist_block: Blokkert av tillatelsesliste
      delivery_statuses:
        blocked_by_kill_switch: Blokkert av nødstopper
        dropped_by_whitelist: Forkastet av tillatelsesliste
        sent: Sendt
        skipped_invalid_recipient: Hoppet over (ugyldig mottaker)
        suppressed_by_user_preference: Undertrykt av brukerpreferanse
      health:
        alert: Høy aktivitet registrert. Se gjennom de siste varslene og vurder å pause en kanal.
        no_activity: Ingen nylig aktivitet
        per_channel_title: Leveranser de siste {minutes} min
        range_15m: Siste 15 min
        range_1h: Siste time
        range_24h: Siste 24 timer
        range_7d: Siste 7 dager
        range_label: Aktivitetsvindu
        top_recipients_title: Mest varslede mottakere ({minutes} min)
      reports:
        channel_breakdown_title: Kanalfordeling
        channel_series_label: Leveranser
        delivery_reason_empty: Ingen leveringsfeil registrert
        delivery_reason_title: Årsaker til leveringsfeil
        delivery_status_all: Alle statuser
        delivery_status_empty: Ingen leveringsstatusdata
        delivery_status_label: Leveringsstatus
        delivery_status_title: Leveringsstatus
        errors:
          preview: Kunne ikke vise mottakerforhåndsvisning
          refresh: Kunne ikke oppdatere rapporten
          trigger: Kunne ikke sende varsel
        failed_job_alerts_channel: 'E-postkanal: {enabled}'
        failed_job_alerts_email_disabled: e-postkanal er deaktivert for denne brukeren
        failed_job_alerts_empty: Ingen brukere har aktivert varsling ennå
        failed_job_alerts_title: Mottakere av e-post ved feilede bakgrunnsjobber
        generated_at: Generert {timestamp}
        headers:
          channels: Kanaler
          delivery_status: Status
          occurrences: Forekomster
          severity: Alvorlighetsgrad
          title: Tittel
          user: Bruker
          when: Tidspunkt
        heading: Portalvarsel-rapport
        no_channel_data: Ingen data
        quick_tests: Hurtigtester for varsler
        read_label: Lest
        read_unread_series_label: Varsler
        read_unread_title: Lest vs ulest
        recent_notifications_title: Siste varsler
        test_default_body: Generert fra admin-rapporten for varsler %{timestamp}
        test_default_title: "%{severity}-testvarsel"
        test_event_type_label: Testtype
        test_events:
          email: E-posttest
          portal: Portal-toast-test
        top_events_header_count: Antall
        top_events_header_event: Hendelse
        top_events_title: Mest brukte hendelser
        top_recipients_header_count: Antall
        top_recipients_header_user: Bruker
        top_recipients_title: Mest varslede mottakere
        totals_line: 'Aktive: {active} • Ulest: {unread}'
        totals_title: Totalt
        trigger_label_prefix: Send
        trigger_label_suffix: ''
        unknown_event: Ukjent
        unread_label: Ulest
      safeguards:
        confirm_disable: Deaktivere {channel}-varsler?
        disabled: Deaktivert
        enabled: Aktiv
        never_disabled: Aldri deaktivert
        recipient_hint: Endringer gjelder straks for nye utsendelser.
        recipient_prompt: Velg en bruker for å styre kanalene.
        recipient_search: Finn mottaker
        recipient_subtitle: Stans kanaler for én bruker i nødsituasjoner.
        recipient_title: Mottaker-override
        recipient_unavailable: Admin-overstyring er ikke tilgjengelig i dette miljøet.
        refresh: Oppdater sikringene
        subtitle: Nødstopp kan pause levering per kanal umiddelbart.
        title: Sikkerhetsbrytere
      tabs:
        compose: Skriv og send
        reports: Rapporter og tester
      tray:
        admin_link: Åpne varslingssenteret
        admin_link_hint: Administrer preferanser og detaljer i huben.
        dismiss: Avslå
        empty: Ingen varsler ennå.
        mark_read: Marker som lest
        more_hint: "... +{count} til —"
        more_link: Se i varslingssenteret
        no_settings_user: Varslingsinnstillinger er ikke tilgjengelig i denne økten.
        settings_link: Administrer varslingsinnstillinger
        similar: leveringer
        tabs:
          notifications: Varsler
          settings: Innstillinger
        view: Vis
    email:
      generic:
        brand_heading: "%{brand}"
        button: Åpne portalen
        footer: Du mottar denne e-posten fordi varsler er aktivert for kontoen din.
        meta:
          attempts: Forsøk
          failed_at: Feilet
          job_class: Jobbklasse
          job_id: Jobb-ID
          queue: Kø
          run_at: Planlagt til
          sent_at: Sendt
        sections:
          details: Leveringsdetaljer
          error_excerpt: Siste feil
          handler_excerpt: Jobbdata
        title: Du har et nytt varsel
    hub:
      actions:
        dismiss_all: Rydd alt
        load_more: Last inn flere
        mark_all_read: Marker alle som lest
        refresh: Oppdater feed
      errors:
        notifications_fetch: Kunne ikke laste varsler.
        notifications_update: Kunne ikke oppdatere varsler. Prøv igjen.
        preference_update: Kunne ikke oppdatere preferanser. Prøv igjen.
      filters:
        range_30d: Siste 30 dager
        range_7d: Siste 7 dager
        range_all: Hele historikken
        range_label: Tidsrom
        severity_all: Alle
        severity_attention: Krever handling
        severity_label: Vis
        severity_success: Vellykket
        severity_updates: Oppdateringer
        visibility_all: Alle elementer
        visibility_label: Status
        visibility_needs_action: Krever handling
        visibility_open: Åpne elementer
        visibility_unread: Kun uleste
      inbox:
        empty: Du er à jour. Nye varsler vises her.
        groups:
          today: I dag
          undated: Uten tidsstempel
          yesterday: I går
        hero_body: Se de siste varslene, hold oversikt over åpne elementer og åpne detaljer fra ett sted.
        hero_title: Ha kontroll
        meta:
          just_now: akkurat nå
          last_refreshed: 'Sist oppdatert: {value}'
          never_refreshed: Ikke synkronisert ennå
          range_label: Tidsrom
          total_label: Totalt varsler
          unread_label: Ulest
        subtitle: Administrer portalvarslene dine og hold varselpanelet ryddig.
        title: Mine varsler
      preferences:
        coming_soon: Kommer snart
        delivery_section_title: Leveringskanaler
        email: E-postvarsel
        email_hint: Send en kopi til innboksen for ekstra trygghet.
        failed_job_alerts: E-post ved jobbfeil
        failed_job_alerts_hint: Kun admin og utvikler. Slå på for å få e-post når bakgrunnsjobber feiler.
        notice: Kritiske kontoeposter (f.eks. passordreset) sendes selv om e-postvarsler slås av.
        sms: SMS-varsel
        sms_hint: SMS-varsler kommer snart.
        subtitle: Velg hvordan du vil varsles. Enkelte transaksjonelle e-poster er alltid på.
        system_opt_ins_hint: Operasjonelle varslingsabonnementer som ikke er standard leveringskanaler.
        system_opt_ins_title: System-innvalg
        title: Leveringskanaler
        toast: Varsel i portal
        toast_hint: Varsler i portalen styrer popup-varsler i sanntid; elementene lagres fortsatt i bjelle og hub.
      tabs:
        inbox: Mine varsler
    system:
      failed_job:
        body: 'En bakgrunnsjobb feilet (jobb #%{job_id}, %{attempts} forsøk).'
        cta: Se i jobbovervåkingen
        preview: Jobb %{job_id} feilet etter %{attempts} forsøk.
        subject: 'Bakgrunnsjobb #%{job_id} feilet'
        title: Bakgrunnsjobb feilet
